import React, { useEffect, useRef } from 'react';
import { Wrapper } from './LandingPage.styled';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer';
import TopBanner from '../../components/TopBanner';
import MidContent from '../../components/MidContent';
import MidContentReverse from '../../components/MidContentReverse';
import WhyChooseUs from '../../components/WhyChooseUse';
import OurGeneratedNft from '../../components/OurGeneratedNft';
import Tokenomics from '../../components/Tokenomics';
import BpunksTokenomics from 'src/components/BpunksTokenomics';
import BpunksRoadMap from 'src/components/BpunksRoadMap';
import BpunksContact from 'src/components/BpunksContact';
import Mint from 'src/components/Mint';
import RecentsMinted from 'src/components/RecentsMinted';
import AboutUs from 'src/components/AboutUs';
import { useLocation } from 'react-router-dom';
import HowToBuy from 'src/components/HowToBuy';

const LandingPage = () => {
    const howToBuyRef = useRef<null | HTMLDivElement>(null);
    const aboutUsRef = useRef<null | HTMLDivElement>(null);
    const roadMapRef = useRef<null | HTMLDivElement>(null);
    const tokenomicsRef = useRef<null | HTMLDivElement>(null);
    const location = useLocation();

    useEffect(() => {
        const hash = location.hash;
        if (hash.toLowerCase().includes('how-to-buy')) {
            howToBuyRef.current?.scrollIntoView({ behavior: 'smooth' });
            return;
        }
        if (hash.toLowerCase().includes('roadmap')) {
            roadMapRef.current?.scrollIntoView({ behavior: 'smooth' });
            return;
        }
        if (hash.toLowerCase().includes('about-us')) {
            aboutUsRef.current?.scrollIntoView({ behavior: 'smooth' });
            return;
        }
        if (hash.toLowerCase().includes('tokenomics')) {
            tokenomicsRef.current?.scrollIntoView({ behavior: 'smooth' });
            return;
        }
    }, [location.hash]);

    return (
        <Wrapper>
            <div className="body-frame">
                <Header />
                <TopBanner />
                <Mint />
                <RecentsMinted />
                <div ref={howToBuyRef}>
                    <HowToBuy />
                </div>
                <div ref={aboutUsRef}>
                    <AboutUs />
                </div>
                {/* <div ref={tokenomicsRef}>
                    <BpunksTokenomics />
                </div> */}
                <div ref={roadMapRef}>
                    <BpunksRoadMap />
                </div>
                <BpunksContact />
            </div>
        </Wrapper>
    );
};

export default LandingPage;
